// Copyright ©️ 2025 eVolve MEP, LLC

/** UOM ID for Spools from Revit. */
export const SPOOL_UOM_ID = '85908275-9d41-4607-9226-e217b48803b7' as const;
